/* eslint-disable react-hooks/exhaustive-deps */
import { decodeJWT } from 'aws-amplify/auth';
import { useEffect, useCallback } from 'react';

export const useSessionExpiry = (
  setIsSessionExpired: React.Dispatch<React.SetStateAction<boolean>>
) => {
  let sessionTimer: NodeJS.Timeout;

  const setupSessionTimer = useCallback(
    (token: string) => {
      try {
        const decodedToken = decodeJWT(token);
        const expiryTime = decodedToken.payload.exp ? decodedToken.payload.exp * 1000 : 0; // Convert to milliseconds
        const currentTime = Date.now();
        const timeUntilExpiry = expiryTime - currentTime;

        if (sessionTimer) {
          clearTimeout(sessionTimer);
        }

        // set a timer with the same timeout as the token expiry
        if (timeUntilExpiry > 0) {
          sessionTimer = setTimeout(() => {
            setIsSessionExpired(true);
            // TODO: it's usually good practice to invoke an FE logout mechanism at this point to clean up any FE session data
            // logout();
          }, timeUntilExpiry);
        }
      } catch (error) {
        console.error('Error setting up session timer:', error);
      }
    },
    [setIsSessionExpired]
  );

  useEffect(() => {
    return () => {
      if (sessionTimer) {
        clearTimeout(sessionTimer);
      }
    };
  }, []);

  return { setupSessionTimer };
};
